import { gridGutterHalf, fontSize12, borderRadiusBase } from '@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout'
import theme from "../../../js/shared/new-theme";
import { css } from "emotion";


export const autoSuggestionWrapper = (withShadow, hasError) => css`
  input {
    box-shadow: ${withShadow ? theme.shadows[200] : 'none'};
    box-sizing: border-box;
  }

  .mainContainer {
    position: relative;

    &[aria-expanded="true"] input {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  .suggestionsContainer {
    position: absolute;
    z-index: 1;
    width: 100%;
  }
  
  .suggestionsList { 
    border: 1px solid ${hasError ? theme.palette.red[500].value : theme.palette.gray[400].value};
    border-top: none;
    background: ${theme.palette.common.white};
    max-height: 250px;
    box-shadow: ${withShadow ? theme.shadows[200] : 'none'};
    margin: 0;
    padding: 0;
    list-style: none;
    overflow-x: hidden;
    overflow-y: scroll;
    border-bottom-left-radius: ${borderRadiusBase};
    border-bottom-right-radius: ${borderRadiusBase};    
  }

  .suggestionHighlighted {
    background: ${theme.palette.gray[100].value};
    transition: all 300ms ease-in-out;
  }
`

export const autoSuggestionItem = css`
  min-height: 50px;
  box-sizing: border-box;
  cursor: pointer;
  font-size: ${fontSize12};
  padding: ${gridGutterHalf}px;
  border-bottom: 1px solid ${theme.palette.gray[400].value};
  display: flex;
  align-items: center;  
`
